import { bytesToBase64Url, utf8Encode } from './encoding';

// Truncating HMAC-SHA256 to 128 bits keeps tokens short (22 base64url chars) while
// preserving collision resistance well past any plausible per-tenant scale.
const TOKEN_BYTES = 16;
const VERIFIER_PLAINTEXT = utf8Encode('cruzfind.verifier.v1');

export async function hmacToken(hmacKey: CryptoKey, fieldValue: string): Promise<string> {
  const sig = await crypto.subtle.sign('HMAC', hmacKey, utf8Encode(fieldValue));
  return bytesToBase64Url(new Uint8Array(sig).slice(0, TOKEN_BYTES));
}

export async function computeVerifier(verifierKey: CryptoKey): Promise<string> {
  const sig = await crypto.subtle.sign('HMAC', verifierKey, VERIFIER_PLAINTEXT);
  return bytesToBase64Url(new Uint8Array(sig));
}
